import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var text_horizontal_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M8.2 14.4h3.9L13 17h1.7L11 6.5H9.3L5.6 17h1.7l.9-2.6zm2-5.5 1.4 4H8.8l1.4-4zm7.4 7.5-1.3.8.8 1.4H5.5V20h14.3l-2.2-3.6z" }) });
export {
  text_horizontal_default as default
};
//# sourceMappingURL=text-horizontal.js.map
